import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useRouteError } from "react-router";
import { Button, Spinner } from "@/shared/ui";
import { canReloadForNewBuild, isStaleBuildError, reloadForNewBuild } from "./staleBuild";

/**
 * Shown instead of a page that failed to render or load. A tab left open across a release is
 * reloaded to the new build; anything else gets a calm message with a way out.
 */
export function RouteErrorPage() {
  const error = useRouteError();
  const { t } = useTranslation();
  const [reloading] = useState(() => isStaleBuildError(error) && canReloadForNewBuild());
  useEffect(() => {
    if (reloading) reloadForNewBuild();
  }, [reloading]);

  if (reloading) {
    return (
      <div className="flex justify-center px-4 py-24">
        <Spinner label={t("errors.newVersion")} />
      </div>
    );
  }
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-4 py-24 text-center">
      <h1 className="text-xl font-semibold text-ink-strong">{t("errors.pageFailedTitle")}</h1>
      <p className="max-w-md text-sm text-muted">{t("errors.pageFailedText")}</p>
      <div className="flex flex-wrap justify-center gap-2">
        <Button
          onClick={() => {
            window.location.reload();
          }}
        >
          {t("errors.reload")}
        </Button>
        <Button asChild variant="secondary">
          <Link to="/">{t("errors.notFoundAction")}</Link>
        </Button>
      </div>
    </div>
  );
}
